import { useContext, useMemo } from 'react';
import GlobalContext, { DefaultGlobalContextValue } from '../../common/context/global';

export default function useProfile() {
  const { profile = DefaultGlobalContextValue.profile, isLoadingContext } = useContext(GlobalContext);
  return useMemo(() => profile || { isLoggedIn: false, isLoadingContext }, [isLoadingContext, profile]);
}
